/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AreaTriggerRecordsFilter = {
    /**
     * Select area trigger records related to one or multiple `area`s
     */
    area?: Array<number>;
    /**
     * Select area trigger records related to one or multiple `area trigger activation`s
     */
    area_trigger?: Array<number>;
    /**
     * Select area trigger records with `body_count` **greater than or equal** to this value
     */
    body_count_gte?: number;
    /**
     * Select area trigger records with `body_count` **less than or equal** to this value
     */
    body_count_lte?: number;
    /**
     * Select objects with `created_date` **greater** than this value
     */
    created_date_gt?: string;
    /**
     * Select objects with `created_date` **greater than or equal** to this value
     */
    created_date_gte?: string;
    /**
     * Select objects with created in last N days
     */
    created_date_last_n_days?: number;
    /**
     * Select objects with `created_date` **less** than this value
     */
    created_date_lt?: string;
    /**
     * Select objects with `created_date` **less than or equal** to this value
     */
    created_date_lte?: string;
    /**
     * Select objects with created in last Nth week (including Sunday and Saturday)
     */
    created_date_nth_full_week?: number;
    /**
     * Select objects with created in last Nth week (only working days, i.e. excluding Sunday and Saturday)
     */
    created_date_nth_work_week?: number;
    /**
     * Number of results to return per page.
     */
    limit?: string;
    /**
     * Which field to use when ordering the results. Available fields: `id`, `created_date`
     */
    ordering?: string;
    /**
     * Pagination cursor value.
     */
    page?: string;
}
export const EmptyAreaTriggerRecordsFilter: AreaTriggerRecordsFilter = {
    area: [],
    area_trigger: [],
    body_count_gte: undefined,
    body_count_lte: undefined,
    created_date_gt: undefined,
    created_date_gte: undefined,
    created_date_last_n_days: undefined,
    created_date_lt: undefined,
    created_date_lte: undefined,
    created_date_nth_full_week: undefined,
    created_date_nth_work_week: undefined,
    limit: '20',
    ordering: undefined,
    page: undefined,
}